export default {
  'de-DE': {
    message: {
      hello: 'Hallo',
      'tom.name': 'Bezeichnung',
      'tom.entryControlDesc': 'Beschreibung der Zugriffskontrolle',
      measureNotes: '',
    },
  },
};
